import SiteBreadCrumb from "../../components/page-breadcrumb/page-breadcrumb.component";
import Typography from "@mui/material/Typography";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getCurrentUser} from "../../store/reducers/user/user.reducer";
import toast from "react-hot-toast";
import sendApiRequest, {NetworkMethods} from "../../lib/Network";
import {ApiResponseModel} from "../../models/apiresponse.model";
import AdvancedTable from "../../components/tables/advanced_table.component";

export interface MessageResponseModel
{
    id: Number;
    name: string;
    email: string;
    message: string;
}

export default function MessagesPage() {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [entries, setEntries] = useState<MessageResponseModel[]>([]);

    const currentUser = useSelector(getCurrentUser);

    useEffect(() => {
        getDataFromServer();

        return () => {};
    }, []);

    const getDataFromServer = async () => {
        try {
            setIsLoading(true);

            const response = await sendApiRequest({
                headers: {
                    "x-public-key": process.env.REACT_APP_PUBLIC_REQUEST_KEY,
                    'Authorization': 'Bearer ' + currentUser.token
                },
                method: NetworkMethods.GET,
                endpoint: `contact`,
            });

            if (!response.isSuccess) {
                toast.error(`Hiba a lekérdezés közben! Indok: ${response?.error ?? "Nincs indok!"}`)
                return
            }

            let apiResponse: ApiResponseModel = response.data;

            setEntries(apiResponse.data);
            setIsLoading(false);
        } catch (error: any) {
            toast.error(`Hiba a lekérdezés közben (${error?.message ?? "Nincs indok!"})!`);
        }
    }

    if (isLoading)
    {
        return <div>Betöltés...</div>
    }

    return (
      <div>
        <SiteBreadCrumb
          sites={[
            {
              name: "Főoldal",
              url: "/",
            },
            {
              name: "Üzenetek",
              url: "/uzenetek",
            },
          ]}
        />
        <Typography variant="h3">Üzenet varázsló</Typography>
        <br />
        <br />
        <AdvancedTable
          columns={["ID", "Név", "E-mail", "Üzenet"]}
          rows={entries.map((entry) => ({
            id: entry.id,
            name: entry.name,
            email: entry.email,
            message: entry.message,
          }))}
          properties={{
            page: 1,
            pages: 1,
            rowsPerPage: 10,
            totalRows: 10,
            disableSee: true,
            disableEdit: true,
            disableDelete: true,
          }}
          rowActions={{
            deleteAction: (row: any) => {},
            editAction: () => {},
            seeAction: (row: any) => {},
          }}
          pageChange={() => {}}
        />
      </div>
    );
}